import { useSafeAreaFrame } from 'react-native-safe-area-context';

import useOrientation from './useOrientation';
import { isTablet } from '../constants';

export default function useDrawerWidth(): number {
  const { width: windowWidth } = useSafeAreaFrame();
  const orientation = useOrientation();
  if (isTablet) {
    if (orientation === 'PORTRAIT') {
      return windowWidth * 0.5;
    } else {
      return windowWidth * 0.33;
    }
  } else {
    return windowWidth * 0.87;
  }
}
